var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list-box-container", attrs: { id: _vm.type.id } },
    [
      [
        _c(
          "div",
          {
            staticClass: "d-flex list-box-header col-12 pointer",
            on: {
              click: function($event) {
                _vm.view($event, _vm.type.id)
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "pl-0 list-box-header-left col-lg-12 col-12 pr-3"
              },
              [
                _c(
                  "div",
                  { staticClass: "pl-0 d-flex align-items-center col-12" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "list-box-status align-items-start col-12"
                      },
                      [
                        _c("span", { staticClass: "ref-id" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.type.name) +
                              "\n            "
                          )
                        ])
                      ]
                    )
                  ]
                )
              ]
            )
          ]
        )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a730032", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a730032","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/ClaimTypes/SettingsClaimTypesBlock.vue
// module id = null
// module chunks = 